import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
import store from '@/store';

Vue.use(VueI18n);

// 自动加载语言文件
const langFiles = require.context('./', false, /^\.\/(?!index|ele\b).*\.js$/);
const customMessages = {};
langFiles.keys().forEach((key) => {
  const langName = key.replace(/(\.\/|\.js)/g, '');
  customMessages[langName] = langFiles(key).default;
});

const supportedLangs = Object.keys(customMessages);
const messages = {};

// 加载 Element 语言
supportedLangs.forEach((lang) => {
  let eleLang = {};
  try {
    eleLang = require(`ele-admin/packages/lang/${lang}`).default;
  } catch (e) {
    try {
      eleLang = require(`./ele/${lang}`).default;
    } catch (e) {
      eleLang = {};
    }
  }
  messages[lang] = { ...customMessages[lang], ...eleLang };
});

// 新增语言需要处理的内容
export const langNames = {
  ar: 'العربية',
  bg: 'Български',
  en: 'English',
  hr: 'Hrvatski',
  hu: 'Magyar', // 匈牙利语
  lt: 'Lietuvių',
  mk: 'Македонски',
  pt: 'Português',
  ro: 'Română',
  sl: 'Slovenščina',
  sr: 'Srpski',
  uk: 'Українська', // 乌克兰语
};
// prettier-ignore
export const countryList = [
 // --- 英文 ---
 'Italy', 'Czech Republic', 'Saudi Arabia', 'United States', 'UK', 'Germany', 'France', 'Canada', 'India', 'China', 'Japan', 'Australia',

 // --- 阿拉伯文 ---
 'إيطاليا', 'جمهورية التشيك', 'المملكة العربية السعودية', 'الولايات المتحدة', 'المملكة المتحدة', 'ألمانيا', 'فرنسا', 'كندا', 'الهند', 'الصين', 'اليابان', 'أستراليا',

 // --- 罗马尼亚文 ---
 'Italia', 'Republica Cehă', 'Arabia Saudită', 'Statele Unite', 'Marea Britanie', 'Germania', 'Franța', 'Canada', 'India', 'China', 'Japonia', 'Australia',

 // --- 保加利亚文 ---
 'Италия', 'Чехия', 'Саудитска Арабия', 'Съединени щати', 'Обединеното кралство', 'Германия', 'Франция', 'Канада', 'Индия', 'Китай', 'Япония', 'Австралия',

 // --- 克罗地亚文 ---
 'Italija', 'Češka', 'Saudijska Arabija', 'Sjedinjene Države', 'Velika Britanija', 'Njemačka', 'Francuska', 'Kanada', 'Indija', 'Kina', 'Japan', 'Australija',

 // --- 匈牙利文 ---
 'Olaszország', 'Csehország', 'Szaúd-Arábia', 'Egyesült Államok', 'Egyesült Királyság', 'Németország', 'Franciaország', 'Kanada', 'India', 'Kína', 'Japán', 'Ausztrália',

 // --- 立陶宛文 ---
 'Italija', 'Čekija', 'Saudo Arabija', 'Jungtinės Valstijos', 'Jungtinė Karalystė', 'Vokietija', 'Prancūzija', 'Kanada', 'Indija', 'Kinija', 'Japonija', 'Australija',

 // --- 葡萄牙文 ---
 'Itália', 'República Checa', 'Arábia Saudita', 'Estados Unidos', 'Reino Unido', 'Alemanha', 'França', 'Canadá', 'Índia', 'China', 'Japão', 'Austrália',

 // --- 斯洛文尼亚文 ---
 'Italija', 'Češka', 'Savdska Arabija', 'Združene države Amerike', 'Združeno kraljestvo', 'Nemčija', 'Francija', 'Kanada', 'Indija', 'Kitajska', 'Japonska', 'Avstralija',

 // --- 马其顿文 ---
 'Италија', 'Чешка', 'Саудиска Арабија', 'Соединети Американски Држави', 'Обединето Кралство', 'Германија', 'Франција', 'Канада', 'Индија', 'Кина', 'Јапонија', 'Австралија',

 // --- 塞尔维亚文（拉丁字母）---
 'Italija', 'Češka', 'Saudijska Arabija', 'Sjedinjene Američke Države', 'Ujedinjeno Kraljevstvo', 'Nemačka', 'Francuska', 'Kanada', 'Indija', 'Kina', 'Japan', 'Australija',

 // --- 乌克兰文 ---
 'Італія', 'Чехія', 'Саудівська Аравія', 'Сполучені Штати', 'Велика Британія', 'Німеччина', 'Франція', 'Канада', 'Індія', 'Китай', 'Японія', 'Австралія',
];

// 校验语言合法性
const isValidLang = (lang) => lang && supportedLangs.includes(lang);

// 核心：仅检测 当前页面 URL 的 ?lang= 参数
export const getUrlLang = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const lang = params.get('lang');
    return isValidLang(lang) ? lang : null;
  } catch {
    return null;
  }
};

// 获取浏览器语言
const getBrowserLang = () => {
  const browserLang = navigator.language || 'en';
  const lang = browserLang.split('-')[0];
  return isValidLang(lang) ? lang : 'en';
};

// ==========================================
// 【唯一修改：这里彻底去掉自动存 localStorage 的代码】
// ==========================================
export const getCurrentLang = () => {
  // 1. URL 参数
  const urlLang = getUrlLang();
  if (urlLang) {
    return urlLang; // 👈 只返回，不存缓存
  }

  // 2. 本地缓存
  const localLang = localStorage.getItem('hippoWebLang');
  if (isValidLang(localLang)) {
    return localLang; // 👈 只返回，不存缓存
  }

  // 3. 浏览器语言
  return getBrowserLang(); // 👈 只返回，不存缓存
};

// 初始化 i18n
const i18n = new VueI18n({
  locale: getCurrentLang(),
  messages,
  silentTranslationWarn: true,
});

// 切换语言
const RTL_LANGUAGES = new Set(['ar']);
export const setRtl = (lang) => {
  document.documentElement.dir = RTL_LANGUAGES.has(lang) ? 'rtl' : 'ltr';
  document.documentElement.className = `${RTL_LANGUAGES.has(lang) ? 'rtl' : 'ltr'} lang-${lang}`;
  document.documentElement.lang = lang;
};
export const setLanguage = (lang) => {
  const finalLang = isValidLang(lang) ? lang : 'en';

  // 👇 只有这里唯一写入缓存！绝对不会被覆盖！
  localStorage.setItem('hippoWebLang', finalLang);

  store.commit('SET_LANGUAGE', finalLang);
  i18n.locale = finalLang;

  // ===================== 【新增：切换语言时同步更新 URL】 =====================
  const url = new URL(window.location.href);
  url.searchParams.set('lang', finalLang);
  window.history.replaceState({}, '', url.href);

  // ===================== 【新增：设置文档方向 RTL/LTR】 =====================
  setRtl(finalLang);
  // document.documentElement.dir = RTL_LANGUAGES.has(finalLang) ? 'rtl' : 'ltr';
  // document.documentElement.lang = finalLang;

  locale.i18n((key, value) => i18n.t(key, value));
};

// 初始化
const initLang = getCurrentLang();
setLanguage(initLang); // 👈 初始化时统一存一次

export { supportedLangs };
export default i18n;
